import React from 'react';
import { LinearProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.1)',
    zIndex: 1
  }
}));

function ProgressBar(props) {
  const classes = useStyles();
  const states = useSelector(state => {
    return state.globalStates
  })
  return(
    <div>
      {
        states.is_loading ? 
        <div className={ classes.root }>
          <LinearProgress/>
        </div> : ""
      }
      
    </div>
  )
}

export default ProgressBar;